import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import React, { useState } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Couples from '../Assets/Couples.jpg';


function Couple() {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <>
            <Card>
                <Card.Img variant="top" src={Couples} />
                <Card.Body>
                    <Card.Title>Couples</Card.Title>
                    <Card.Text>
                        Relationships can become sour and misunderstandings happen because of disappointments, Let's manage them.
                    </Card.Text>
                    <Button style={{backgroundColor:"#6883BC",borderRadius: "0",border: "none"}} onClick={handleShow}>Know More</Button>
                </Card.Body>
            </Card>
            <Offcanvas show={show} onHide={handleClose} style={{ width: "-webkit-fill-available" }}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>COUPLE/MARITAL THERAPY</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <p>Couples often report that communications get misunderstood and broken , a feeling of sourness
                        creeps in and leads to distrust in relationships.</p>
                    <p>Couple therapy will help us to benefit and cope with each other. It will help us to understand
                        the ultimate question IS LOVE ONLY SUFFICIENT?</p>
                    <p>Love is necessary for a fulfilling relationship but not sufficient. Relationships require combined
                        effort from both ends. It includes communication, compatibility, healthy boundaries, empathy ,
                        understanding, reciprocating, etc. So the ultimate aim of Couples therapy will help you achieve
                        these factors. Sometimes it helps us to move on from a relationship that is beyond repair.</p>
                    <h5>How Couple Therapy Can Help</h5>
                    <p><b>Gathering Information</b><br />It eases the air between the partners and they feel heard and understood as their
                        struggles are acknowledged by the therapist. Time and effective listening are two tools
                        which provide for a safe space for exploration of their concerns.</p>
                    <p><b>Communication</b><br />The Therapist acts as a facilitator to let the partners communicate through him/her to
                        help have a talk and reach an outcome.</p>
                    <p><b>The Main Concern</b><br />Through the session the concern of the couple is understood, the reason behind the
                        quarrel, misunderstanding or disputes can be revealed..</p>
                    <p><b>Beyond Interpretations</b><br />Through the Therapists eye the couple will be able to see their partners beyond their
                        personal assumptions and interpretation.</p>
                    <p><b>What Next?</b><br />Therapy can empower the partners to understand what is conducive for them
                        individually and as a couple, and help them proceed further by deciding future goals.</p>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default Couple;